import angular from 'angular';
import _ from 'lodash';
import deleteModalTemplate from './category.delete.modal.html';

class MenuCategoriesController {
  /* @ngInject */
  constructor($rootScope, CatalogService, ProductsStore, ProductsActions, StoreStates, ModalFactory, $timeout, $translate) {
    const that = this;

    that.loading = {
      categories: false,
      subCategories: false,
    };

    const loadCategories = () => {
      that.error = undefined;
      if (ProductsStore.getCategoriesStoreState() === StoreStates.STORE_VALID) {
        that.categories = ProductsStore.getCategories();

        that.loading.categories = false;
      } else if (ProductsStore.getCategoriesStoreState() !== StoreStates.STORE_PENDING_UPDATE) {
        that.loading.categories = true;
        ProductsActions.getCategories(true);
      }
    };


    const init = () => {
      loadCategories()
    };

    that.$onInit = init;

    that.addSubcategory = (parentId) => {
      $rootScope.parentId = parentId;
      const modal = new ModalFactory({
        overlay: true,
        overlayClose: false,
        class: 'large',
        template: '<edit-category mode="create" on-cancel="cancel()"></edit-category>',
        contentScope: {
          cancel: () => closeModal(modal), 
        }
      });

      modal.activate();
    };

    that.deleteCategory = category => {
      const modal = new ModalFactory({
        ovarlay: true,
        overlayClose: false,
        template: deleteModalTemplate,
        class: 'medium',
        contentScope: {
          description: $translate.instant('menu.category.delete.body.description', {
            name: category.name,
          }),
          cancel: () => closeModal(modal),
          delete: () => {
            CatalogService.deleteCategory(category.id).then(
              () => {
                ProductsStore.forceCategoryExpired()
                $rootScope.$broadcast('CATEGORIES_UPDATE');
                closeModal(modal);
              }
            )
            
          }
        }
      });
      modal.activate();
    }

    const closeModal = modal => {
      modal.deactivate();
      $timeout(modal.destroy, 1000);
    };

    const deregCategoriesUpdateListener = $rootScope.$on('CATEGORIES_UPDATE', loadCategories);

    that.$onDestroy = () => {
      deregCategoriesUpdateListener();
    };
  }
}

export default MenuCategoriesController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/categories/categories.controller.js
 **/